import React from 'react';

import { Icon } from '@99designs/common/components/Icon';
import { getComponentClasses } from '@99designs/common/utils/app';
import Mediabox from 'common/components/Mediabox';
import ProgressBar from 'common/components/ProgressBar';
import IconButton from 'launch/components/IconButton';

export interface Props {
    name: string;
    onDelete: () => void;
    children: any;
}

export const Attachment: React.SFC<Props> = props => (
    <Mediabox meta={<Meta {...props} />}>{props.children}</Mediabox>
);

export interface Props {
    name: string;
    onDelete: () => void;
    children: any;
}

export const AttachmentPreview: React.SFC<{ previewable?: boolean; url?: string }> = props => (
    <UploaderAttachmentOverlay>
        {props.previewable ? (
            <img src={props.url} className="uploader-attachment-thumbnail" />
        ) : (
            <Icon type={'document-1'} variations={['2x']} />
        )}
    </UploaderAttachmentOverlay>
);

export const UploaderAttachmentFileInput: React.SFC<{
    onClick: (target: HTMLInputElement) => void;
}> = ({ onClick, children }) => (
    <div className="uploader-attachment-file-input">
        <UploaderAttachmentOverlay variations={['outline']}>
            <div className="uploader-attachment-overlay__content__icon">
                <Icon type={'plus-2'} />
            </div>
            <div className="uploader-attachment-overlay__content__label">{children}</div>
        </UploaderAttachmentOverlay>
        <input
            key={Date.now()}
            type="file"
            onChange={e => onClick(e.target)}
            className="uploader-attachment-file-input__target"
            multiple
        />
    </div>
);

export const UploaderAttachmentProgress = ({
    completed,
    total,
}: {
    completed: number;
    total: number;
}) => {
    const percentage = Math.min(Math.round((completed / total) * 100), 100);
    return (
        <UploaderAttachmentOverlay variations={['shaded']}>
            <div className="heading heading--h5">{percentage + '%'}</div>
            <div className="uploader-attachment-overlay__progress-bar">
                <ProgressBar variations={['rounded', 'small']} percentageComplete={percentage} />
            </div>
        </UploaderAttachmentOverlay>
    );
};

const Meta: React.SFC<{ name: string; onDelete: () => void }> = props => (
    <div className="uploader-attachment-file-meta">
        <div className="uploader-attachment-file-meta__action">
            <IconButton
                onClick={props.onDelete}
                variations={['lighter', 'on-white']}
                icon={'trash-2'}
            />
        </div>
        <div className="uploader-attachment-file-meta__label">
            <span>{props.name}</span>
        </div>
    </div>
);

const UploaderAttachmentOverlay: React.SFC<{ variations?: string[] }> = ({
    children,
    variations,
}) => {
    const classes = getComponentClasses('uploader-attachment-overlay', variations);
    const innerClasses = getComponentClasses('uploader-attachment-overlay__inner', variations);

    return (
        <div className={classes}>
            <div className={innerClasses}>
                <div className="uploader-attachment-overlay__content">{children}</div>
            </div>
        </div>
    );
};
